"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPPLIER_CONFIG_REPLICATION = void 0;
exports.SUPPLIER_CONFIG_REPLICATION = {
    MISSING_CONFIGS: {
        usecase: "SUPPLIER_CONFIG_REPLICATION",
        type: "MISSING_CONFIGS",
        messageLangMap: {
            "PT-BR": "Perfil de cobrança selecionado deve ter todos os fornecedores configurados para ser replicado.",
        },
    },
    ALREADY_HAS_CONFIGS: {
        usecase: "SUPPLIER_CONFIG_REPLICATION",
        type: "ALREADY_HAS_CONFIGS",
        messageLangMap: {
            "PT-BR": "Este perfil de cobrança já possui fornecedores configurados.",
        },
    },
    SUPPORT_USER_NOT_FOUND: {
        usecase: "SUPPLIER_CONFIG_REPLICATION",
        type: "SUPPORT_USER_NOT_FOUND",
        messageLangMap: {
            "PT-BR": "Aconteceu um erro inesperado.",
        },
    },
};
